/* eslint-disable */

import {bus} from '@/main';
import toast from '@/services/toast';

export default {
  name: 'add-new-user',
  components: {},
  props: [],
  data() {
    return {
      email: '',
      password: '',
      submitted: false,
    }
  },
  computed: {

  },
  mounted() {

  },
  methods: {
    getUserListAgain() {
      this.$store.dispatch('getUserListDetails').then((res) => {
        bus.$emit('HideAddNewUserPopup', false);
      }).catch((err) => {})
    },
    validateCreateUserBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true;
          let data = {
            email: this.email,
            password: this.password
          }
          this.$store.dispatch('createUserList', data).then((res) => {
            if (res.status == '200' || res.status == '201') {
              toast.success(res.data.msg);
              this.getUserListAgain()
              this.$validator.reset();
            }
          }).catch((err) => {})
          return;
        }
      });
    },
    PopupClose() {
      bus.$emit('HideAddNewUserPopup', false);
    },
  }
}